
import { defineComponent } from "vue";
import { ViewOrder } from "@/services/Models";

export default defineComponent({
  name: "EditDownloadSelectOutputOrder",
  props: {
    order: { type: Number },
  },
  setup(props, context) {
    const pattern00 = { id: 1, order: ViewOrder.RTLB };
    const pattern01 = { id: 2, order: ViewOrder.LTRB };

    const updateValue = (e: InputEvent) => {
      const elm = e.target as HTMLInputElement;
      if (elm.checked) {
        const pattern = [pattern00, pattern01].find(
          (p) => p.id == Number.parseInt(elm.value)
        );
        if (pattern === undefined) return;
        context.emit("update:order", pattern.order);
      }
    };

    return {
      updateValue,
      pattern00,
      pattern01,
    };
  },
});
